import { render } from "./AddGroupAndType.vue?vue&type=template&id=5600a886&scoped=true"
import script from "./AddGroupAndType.vue?vue&type=script&lang=js"
export * from "./AddGroupAndType.vue?vue&type=script&lang=js"

import "./AddGroupAndType.vue?vue&type=style&index=0&id=5600a886&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5600a886"]])

export default __exports__